<template>
  <div>
    <div align="left">
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd">
      </el-date-picker>

      <el-select v-model="hospital" filterable clearable placeholder="请选择医疗企业" style="width: 200px">
        <el-option
          v-for="item in hospitals"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>

      <el-button type="primary" icon="el-icon-circle-plus" :loading="loading" @click="query" >查询</el-button>
      <el-button type="danger" icon="el-icon-delete" @click="openDelDialog" >删除指定导入数据</el-button>
    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
      max-height="100%">
      <el-table-column
        type="index"
        label="序号"
        width="70"
        :index="indexMethod">
      </el-table-column>
      <el-table-column
        prop="id"
        label="ID"
        width="80">
      </el-table-column>
      <el-table-column
        prop="date"
        label="日期"
        width="120">
      </el-table-column>
      <el-table-column
        prop="hospital_code"
        label="医院编号"
        width="140">
      </el-table-column>
      <el-table-column
        prop="hospital_name"
        label="医院名称"
        width="300">
      </el-table-column>
      <el-table-column
        prop="amount"
        label="金额（元）"
        width="140">
        <template slot-scope="scope">
          <span :style="scope.row.amount<0?'color:#F56C6C':''">{{(scope.row.amount/100).toFixed(2)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="operator"
        label="操作人"
        width="120">
      </el-table-column>
      <el-table-column
        prop="time"
        label="提交时间"
        width="180">
        <template slot-scope="scope">
          {{formatTime(scope.row.time)}}
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10,20,50,100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog title="删除指定导入数据" :visible.sync="delDialogVisible">
      <el-form :model="delForm">
        <el-form-item label="提交时间" :label-width="'100px'">
          <el-date-picker
            v-model="delForm.time"
            type="datetime"
            placeholder="选择提交时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="delDialogVisible=false">取 消</el-button>
        <el-button type="danger" @click="delOrder" :loading="delLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import coder from "./enum.js"
export default {
  methods: {
    indexMethod(index) {
      return index + 1;
    },
    formatTime(time) {
      if (time === null || time === undefined || time === '') {
        return '';
      }
      const date = new Date(time);
      if (isNaN(date.getTime())) {
        return time;
      }
      const pad = n => (n < 10 ? '0' + n : '' + n);
      return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()) +
        ' ' + pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds());
    },
    query(){
      if (this.loading){ return }
      this.loading=true;
      let start='',end='';
      if (this.dateRange!=null&&this.dateRange.length===2){
        start=this.dateRange[0];
        end=this.dateRange[1];
      }
      window.ws.Call("W2S_OrderList", start, end, this.hospital.split(" ")[0], this.page, this.pageSize);
    },
    handleSizeChange(e){
      this.pageSize=e;
      this.page=1;
      this.query();
    },
    handleCurrentChange(e){
      this.page=e;
      this.query();
    },
    openDelDialog(){
      this.delForm.time='';
      this.delDialogVisible=true;
    },
    delOrder(){
      if (this.delForm.time===''||this.delForm.time===null||this.delForm.time===undefined){
        this.$alert('请选择提交时间', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      if (this.delLoading){ return }
      this.delLoading=true;
      let $this=this;
      window.ws.AddFunc("S2W_DelOrderRes",function (code,msg) {
        $this.delLoading=false;
        if (code===coder.OK){
          $this.$notify({
            title: '成功',
            message: msg||'删除成功',
            type: 'success'
          });
          $this.delDialogVisible=false;
          $this.query();
        }else{
          $this.$alert(msg+'('+code+')', '错误', {
            confirmButtonText: '确定'
          });
        }
      });
      window.ws.Call("W2S_DelOrder", this.delForm.time);
    }
  },
  mounted() {
    let $this=this;
    console.log("###Page loaded !");

    if (window.hospitals===null||window.hospitals===undefined||window.hospitals.length===0){
      window.ws.AddFunc("S2W_GetHospitalNamesRes",function(list){
        let names = [];
        for(let i=0;i<list.length;i++){
          names.push({value:list[i],label:list[i]})
        }
        $this.hospitals=names;
        window.hospitals=names;
      });
      window.ws.Call("W2S_GetHospitalNames");
    }else{
      this.hospitals=window.hospitals;
    }

    window.ws.AddFunc("S2W_OrderListRes",function (code,err,list) {
      console.log("S2W_OrderListRes:",code,err,list)
      $this.loading=false;
      if (code==coder.OK){
        $this.tableData=list;
        $this.total=list.length;
      }else{
        $this.$alert(err+'('+code+')', '错误', {
          confirmButtonText: '确定'
        });
      }
    });
    this.query();
  },
  data() {
    return {
      page:1,
      pageSize:10,
      total:0,
      tableData: [],
      dateRange: [],
      hospital:'',
      loading:false,
      hospitals:[],
      delDialogVisible:false,
      delLoading:false,
      delForm: {
        time:''
      },
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/OrderList.vue